import { GenericService } from '../../../../core/services/GenericService';
import { Injectable } from '@angular/core';
import { ApiService } from '../../../../core/services';
import { ICartonType } from '../interfaces/ICartonType';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CartonsService extends GenericService<ICartonType> {
  protected readonly baseUrl = '/cartons';

  constructor(public apiService: ApiService) {
    super(apiService);
  }

  getActive(): Observable<ICartonType[]> {
    return this.apiService.get(`${this.baseUrl}/simple`);
  }

  adjustStock(id: number, delta: number, comment: string): Observable<void> {
    return this.apiService.post(`${this.baseUrl}/${id}/stock`, { delta, comment });
  }
}
